import router from '~/router';

export default class RouterHelper {
  static ROUTES = {
    0: 'settings',
    1: 'event',
    2: 'planning.main',
    3: 'categorization',
  };

  static defaultRoute(user) {
    if (user) {
      if (user.defaultDashboard()) {
        return {
          name: 'dashboardId',
          params: { value: user.defaultDashboard().id },
        };
      }

      if (RouterHelper.ROUTES[parseInt(user.startingDashboard, 10)]) {
        return {
          name: RouterHelper.ROUTES[parseInt(user.startingDashboard, 10)],
          params: {},
        };
      }
    }

    return {
      name: 'settings',
      params: {},
    };
  }

  /**
   * Get URL from route name.
   * @param {string} name
   * @param {object} [params={}]
   * @returns {string|null}
   */
  static resolvePathFromName(name, params = {}) {
    try {
      const route = router.resolve({ name, params });
      return route?.href ?? null;
    } catch (err) {
      console.warn(`route "${name}" not found`, err);
      return null;
    }
  }
}

/**
 * Returns ihm current route
 * @param routeName
 * @returns {boolean}
 */
export function isCurrentRoute(routeName) {
  return this.$route.matched.some((item) => item.name === routeName);
}
